import { useNavigate } from "react-router-dom";

import { ReactComponent as ArrowLeft } from "assets/images/iconsV2/arrow-left.svg";
import testIds from "constants/testIds";
import { useRouteHistory } from "hooks/useRouteHistory";

function TopNavBackButton() {
  const navigate = useNavigate();
  const { lastEntryRoute } = useRouteHistory();

  return (
    <button
      type="button"
      className="topnav-v2__back-btn"
      onClick={() => navigate(lastEntryRoute)}
      aria-label="back"
      data-testid={testIds.TOPNAV_V2_BACK_BUTTON}
    >
      <ArrowLeft className="topnav-v2__back-icon" data-testid={testIds.TOPNAV_V2_BACK_ICON} />
    </button>
  );
}

export default TopNavBackButton;
